import { render, staticRenderFns } from "./pending-delivery.vue?vue&type=template&id=65e2dbe4&"
import script from "./pending-delivery.vue?vue&type=script&lang=js&"
export * from "./pending-delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports